import PropTypes from 'prop-types'
import { Box, Grid, Typography } from '@mui/material'

import useTranslations from '../../i18n/useTranslations'
import Loader from '../../ui/views/Loader'

import EmptyState from './EmptyState'
import useStyles from './styles'

const HomeView = ({ children, isLoading, username, noData }) => {
  const classes = useStyles()
  const t = useTranslations()

  if (isLoading) {
    return <Loader />
  }

  return (
    <Box>
      <Typography variant="h1" className={classes.title}>
        {t('home:welcome', { name: username ?? 'unnamed' })}
      </Typography>
      {noData ? (
        <EmptyState />
      ) : (
        <Grid container spacing={4}>
          {children}
        </Grid>
      )}
    </Box>
  )
}

HomeView.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  username: PropTypes.string,
  noData: PropTypes.bool.isRequired,
}

export default HomeView
